import ArbitrumLOCKER from "@core/currencies/arbitrum/locker/ArbitrumLKT";
import LOCKER from "@core/currencies/ethereum/locker/LOCKER";

const CustomCurrencies = [
   LOCKER,
   ArbitrumLOCKER
]

export {CustomCurrencies} ;